<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Neuer Mandant</h4>
    </div>
    <div class="card-body">
        <div class="row" style="margin-top: 10px;">
            <div class="col-md-10">
                <mat-form-field class="example-full-width">
                    <mat-label>Scope</mat-label>
                    <mat-select [(ngModel)]="selectedScope" required>
                        <mat-option *ngFor="let scope of scopes" [value]="scope">
                            <span><b>{{ scope.name }}</b></span>
                        </mat-option>
                     </mat-select>
                </mat-form-field>
            </div>
        </div>

      <!-- wpServerUrl: [null, Validators.required],
      wpTenantName: [null, Validators.required],
      wpApiKey: [null, Validators.required], -->


        <form [formGroup]="tenantForm" novalidate *ngIf="selectedScope">
            <div class="row" *ngIf="!(selectedScope.systemtype === 'WINPLAN')">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['INPUTTENANTNAME'] | translate}}" formControlName="name" required>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" *ngIf="selectedScope.systemtype === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Server Url" formControlName="wpServerUrl" required>
                    </mat-form-field>
                </div>
            </div>

                <div class="row" *ngIf="selectedScope.systemtype === 'WINPLAN'">
                    <div class="col-md-12">
                        <mat-form-field class="example-full-width">
                            <input matInput placeholder="Winplan Mandant" formControlName="wpTenantName" required>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row" *ngIf="selectedScope.systemtype === 'WINPLAN'">
                    <div class="col-md-12">
                        <mat-form-field class="example-full-width">
                            <input matInput placeholder="Winplan Api User" formControlName="wpApiUser" required>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row" *ngIf="selectedScope.systemtype === 'WINPLAN'">
                    <div class="col-md-12">
                        <mat-form-field class="example-full-width">
                            <input matInput placeholder="Winplan Api Key" formControlName="wpApiKey" required>
                        </mat-form-field>
                    </div>
                </div>

            <div class="row" *ngIf="selectedScope.systemtype === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan API Key Inbound" formControlName="wpApiKeyInbound" required>
                    </mat-form-field>
                </div>
            </div>

            <h5>Administrator des Mandanten (E-Mail Adresse):</h5>        

            <div class="row" style="margin-top: -20px;">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width" *ngIf="!userSelected">
                        <!-- <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="responsibleUser" [matAutocomplete]="auto" (input)="onInput($event)"> -->
                        <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="responsibleUser" [matAutocomplete]="auto">

                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                            (optionSelected)="optionUserSelected($event)">
                            <!-- <mat-option *ngIf="isLoading" class="is-loading">
                                <mat-spinner diameter="50"></mat-spinner>
                            </mat-option> -->
                            <ng-container *ngIf="!isLoading">
                                <mat-option *ngFor="let user of users" [value]="user">
                                    <span><b>{{ user.userName }}</b> - {{ user.email }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                    <a class="a-color" *ngIf="userSelected && selectedUserEmail != ''">{{selectedUserEmail}}</a>
                </div>
            </div>
        </form>

        <div class="row">
            <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                (click)="cancel()" >Abbruch</button>
            </a>                                                
            <span style="flex: 1 1 auto"></span>
            <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Mandanten Informationen in die Zwischenablage kopieren"
                                (click)="copy()" >Kopieren</button>
            </a>                   
            <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDTENANT'] | translate}}"
                                (click)="add()" [disabled]="!isFormValid()" >Hinzufügen</button>
            </a>                   

        </div>    
</div>
</div>